import { render, staticRenderFns } from "./auditTicketAffiliate.vue?vue&type=template&id=0cff3944&lang=pug"
import script from "./auditTicketAffiliate.vue?vue&type=script&lang=js"
export * from "./auditTicketAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports